<template>
  <a-card :bordered="false" class="widget-1">
    <div class="ant-statistic-title">{{ title }}</div>
    <a-statistic
      :value="value"
      :prefix="prefix"
      :precision="0"
      class="text-success"
      :class="'text-' + status"
    >
    </a-statistic>
    <div class="suffix">{{ suffix }}</div>
  </a-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: Number,
      default: 0,
    },
    prefix: {
      type: String,
      default: "",
    },
    suffix: {
      type: String,
      default: "",
    },
    status: {
      type: String,
      default: "success",
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.suffix{
	color: #52c41a;
	font-family: "open sans", Arial, Helvetica, sans-serif;
	font-weight: 700;
	font-size: 14px;
	height: 21px;
	margin-top: 4px;
}
</style>